export const ACT_DISCONTINUE = 'discontinue';
export const ACT_EMAIL_HISTORY = 'emailHistory';
export const ACT_REASSIGN = 'reassign';
export const ACT_EXPORT = 'export';
export const ACT_NOTIFY = 'notify';

// Reorder actions to set the default order
export const ACTION_BUTTONS_MAP = {
  [ACT_EXPORT]: 'Export',
  [ACT_REASSIGN]: 'Reassign',
  [ACT_DISCONTINUE]: 'Cancel',
  [ACT_EMAIL_HISTORY]: 'Email History',
  [ACT_NOTIFY]: 'Notify',
};

export const ACTION_BUTTONS_MAP_INACTIVE = {
  [ACT_REASSIGN]: 'Reassign',
  [ACT_DISCONTINUE]: 'Cancel',
  [ACT_EXPORT]: 'Export',
  [ACT_EMAIL_HISTORY]: 'Email History',
  [ACT_NOTIFY]: 'Notify',
};

export const ACTION_BUTTONS_ICON = {
  [ACT_DISCONTINUE]: 'Reject',
  [ACT_EMAIL_HISTORY]: 'Mail',
  [ACT_REASSIGN]: 'Reassign',
  [ACT_EXPORT]: 'Export',
  [ACT_NOTIFY]: 'Notification',
};

// Tab keys and labels
export const CERTS_LIST_TODO_TAB = 'toDo';
export const CERTS_LIST_DONE_TAB = 'done';
export const CERTS_LIST_CANCELED_TAB = 'cancelled';
export const CERTS_LIST_EXPIRED_TAB = 'expired';
export const CERTS_LIST_ALL_TAB = 'all';

export const CERTS_LIST_TAB_LABELS = {
  [CERTS_LIST_TODO_TAB]: 'To Do',
  [CERTS_LIST_DONE_TAB]: 'Done',
  [CERTS_LIST_CANCELED_TAB]: 'Cancelled',
  [CERTS_LIST_EXPIRED_TAB]: 'Expired',
  [CERTS_LIST_ALL_TAB]: 'All',
};

export const CERTS_LIST_ADMIN_TAB_LABELS = {
  [CERTS_LIST_TODO_TAB]: 'Incomplete',
  [CERTS_LIST_DONE_TAB]: 'Complete',
  [CERTS_LIST_CANCELED_TAB]: 'Cancelled',
  [CERTS_LIST_EXPIRED_TAB]: 'Expired',
  [CERTS_LIST_ALL_TAB]: 'All',
};

// Status to send to list api for each tab
export const CERTS_LIST_STATUS = {
  [CERTS_LIST_TODO_TAB]: 'new,inprogress,readytosubmit',
  [CERTS_LIST_DONE_TAB]: 'lockedandtaskcreated,fullyexecuted,locked',
  [CERTS_LIST_CANCELED_TAB]: 'discontinued',
  [CERTS_LIST_EXPIRED_TAB]: 'expired',
  // [CERTS_LIST_ALL_TAB]: '',
};

export const CERTS_LIST_PREVIEW_STATUS = 'preview';
export const CERTS_LIST_ALL_STATUS =
  'new,inprogress,readytosubmit,lockedandtaskcreated,fullyexecuted,locked,discontinued,expired,preview';

export const ACTION_BUTTON_FOOTER_KIND = {
  footer: 'sidepanel',
  tile: 'tile',
};

export const CERTS_LIST_PREDEFINED_COMMENTS_FOR_ACTION = {
  CERTS_LIST_REASSIGN: 'CERTLISTREASSIGN',
  CERT_LIST_CANCEL: 'CERTLISTCANCEL',
};
